"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports["default"] = void 0;
exports.get = get;
exports.getAll = getAll;
exports.getByGroup = getByGroup;
exports.getTemplateData = getTemplateData;
exports.sendTemplate = sendTemplate;
exports.update = update;

var _api = _interopRequireWildcard(require("./api"));

var _queryString = _interopRequireDefault(require("query-string"));

var _lib = require("./lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var base = '/api/email-template';

function get(templateId) {
  return _api["default"].get("".concat(base, "/").concat(templateId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAll() {
  return _api["default"].get("".concat(base)).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(id, template) {
  return _api["default"].put("".concat(base, "/").concat(id), template).then(_api.extractData)["catch"](_api.errorHandler);
}

function create(data) {
  return _api["default"].post("".concat(base), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function getByGroup(group) {
  var queryParams = _queryString["default"].stringify({
    fields: ['id', 'name', 'groupDefault']
  });

  return _api["default"].get("".concat(base, "/group/").concat(group, "?").concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getTemplateData(url, templateName) {
  var base = url.split('?')[1];

  if (templateName.includes('follow_up') || !base) {
    url = (0, _lib.addQueryParams)(url, {
      templateName: templateName
    });
    return _api["default"].get(url).then(_api.extractData)["catch"](_api.errorHandler);
  }

  var data = base.split('&').map(function (s) {
    return _defineProperty({}, s.split('=')[0], s.split('=')[1]);
  });
  var payload = {
    templateName: templateName,
    segmentId: parseInt(data.find(function (d) {
      return d.segmentId;
    }).segmentId),
    expertIds: data.filter(function (d) {
      return d.expertIds;
    }).map(function (id) {
      return parseInt(id.expertIds);
    })
  };
  return _api["default"].post('/api/expert-project-link/expert-invite-template', payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendTemplate(url, template) {
  return _api["default"].post(url, template).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  get: get,
  getAll: getAll,
  update: update,
  getByGroup: getByGroup,
  getTemplateData: getTemplateData,
  sendTemplate: sendTemplate,
  create: create
};
var _default = api;
exports["default"] = _default;